<template>
	<ProcessCreatePage>
		<Header :title="title">
			<p>{{ $t('need_person_sign') }} <strong>Kunden</strong> {{ $t('lawyer_sign_customer') }}</p>
		</Header>

		<div class="main flex justify-around">
			<BaseSign v-if="isShown" ref="BaseSign" v-model="sign" />
			<div>
				<PDFThumbnailPreview :pdf-u-r-l="pdfURL" :uuid="uuid" show-route-params="true" :type="pdfType" />
			</div>
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			:disable-buttons="isLoading"
			@continueButtonClick="continueButtonClick(false)"
			@skipButtonClick="continueButtonClick(true)"
			:is-skippable="isSkippable"
		/>
	</ProcessCreatePage>
</template>

<script>
import Header from '../Header';
import Footer from '../Footer';
import BaseSign from '../../forms/inputs/BaseSign';
import { PdfApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import { PDFTypes } from '@/api/generated/models';
import PDFThumbnailPreview from '@/components/damagecases/forms/PDFThumbnailPreview';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';

export default {
	name: 'SignLawyer',
	components: { ProcessCreatePage, PDFThumbnailPreview, BaseSign, Footer, Header },
	data() {
		return {
			sign: null,
			pdfURL: '',
			uuid: '',
			isLoading: false,
		};
	},
	props: {
		isShown: { type: Boolean, default: false },
		damageCase: { required: true },
		title: {
			default: function() {
				return this.$t('generate_form_sign_customer');
			},
		},
		defaultCity: {
			type: String,
			required: true,
		},
	},
	computed: {
		pdfType() {
			return PDFTypes.LawyerPaymentOrder;
		},
		isSkippable() {
			return this.defaultCity !== this.damageCase.signLocation;
		},
	},
	methods: {
		continueButtonClick: function(isSkip) {
			this.isLoading = true;
			if (isSkip) {
				this.$emit('next', null);
				this.isLoading = false;
			} else if (this.sign || this.isSkippable) {
				this.$emit('next', { lawyerSign: this.sign });
				this.isLoading = false;
			} else {
				this.isLoading = false;
				this.$swal(this.$t('general.attention').toString(), this.$t('sign_process').toString(), 'warning');
			}
		},
		getPDF() {
			this.pdfURL = '';
			PdfApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.pdfDamagecasesTypeTempSavePost(this.pdfType, {
					...this.damageCase,
					lawyerSign: this.sign,
				})
				.then(res => {
					this.uuid = res.data.uuid;
					this.pdfURL = apiDefaults.axios.defaults.baseURL + 'api/pdf/damagecases/' + res.data.uuid + '/temp/file#toolbar=0&navpanes=0&scrollbar=0';
				});
		},
	},
	watch: {
		isShown: function() {
			if (this.isShown) {
				this.getPDF();
			}
		},
		sign() {
			this.getPDF();
		},
	},
};
</script>

<style scoped></style>
